import { z } from 'zod';
import { articleSchema } from './articleSchema';

export const annotationSchema = z.object({
  link: z.string().url().nullable(),
  article: articleSchema.optional().nullable(),
  type: z.string(),
  resource: z.string(),
  id: z.number(),
  annotator: z.string().nullable(),
});

const MAX_RESOURCE_LENGTH = 255;
const MIN_FIELD_LENGTH = 1;

export const annotationDataSchema = z.object({
  type: z.string().min(MIN_FIELD_LENGTH),
  resource: z.string().min(MIN_FIELD_LENGTH).max(MAX_RESOURCE_LENGTH),
});
